import React from 'react';
import cx from 'classnames';
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';
import renderAsBackgroundImage from '~/libs/server/utils/renderAsBackgroundImage';

import ImageSection from '~/components/ui/ImageSection';
import { bgColorOption } from '~/components/ui/ImageSection/types';

import heroStyles from '~/components/ui/Hero/_heroV2--shared.module.less';
import imageSectionStyles from '~/components/ui/ImageSection/_imageSection--shared.module.less';
import sharedLpStyles from '~/styles/landingPageShared.module.less';
import EverythingYouAndGuestsWant from '../EverythingYouAndGuestsWant';
import styles from './Hero.module.less';

type HeroProps = {
  onCTAClick: () => void;
};

const Hero: React.FC<HeroProps> = ({ onCTAClick }): JSX.Element => {
  const renderButtons = () => (
    <div className={styles.btnSpacing}>
      <ButtonV3 component="a" variant="primary" onClick={onCTAClick}>
        Build Your Registry
      </ButtonV3>
    </div>
  );

  const renderText = () => (
    <div className={cx(sharedLpStyles.dek, styles.secondaryContentsOverride)}>
      Find out what makes us unlike any other registry.
    </div>
  );

  return (
    <>
      <ImageSection
        headerTag="div"
        backgroundColor={bgColorOption.lightGray}
        title={
          <>
            <h1 className={cx(heroStyles.title, styles.title)}>
              All the Benefits of Zola Registry
            </h1>
            {renderText()}
            {renderButtons()}
          </>
        }
        textPosition="left"
        imageContents={
          <div className={styles.imgContainer}>
            <div className={cx(styles.secondaryImage)}>
              <span role="img" aria-label="custom photo background registry benefits" />
            </div>
            {renderAsBackgroundImage({
              selector: `.${styles.secondaryImage}`,
              backgroundImageName: 'registry_benefits_hero',
              directory: 'WeddingRegistryBenefitsLP/hero',
              filetype: ['png', 'png', 'png'],
            })}
          </div>
        }
        titleOnTop
      >
        <div className={cx(sharedLpStyles.sectionTitle, styles.subtitle)}>
          We Have Everything You and Your Guests Want
        </div>
      </ImageSection>
      <div className={cx(imageSectionStyles.outer, styles.outerColor)}>
        <div className={cx(styles.infoTilesContainer, sharedLpStyles.borderBottom)}>
          <EverythingYouAndGuestsWant />
        </div>
      </div>
      <object className={styles.shadow} aria-label="shadow" aria-hidden="true" />
    </>
  );
};

export default Hero;
